/** Primary navigation bar height in px — keep layout offsets in sync with side panels. */
export const PRIMARY_NAV_HEIGHT_PX = 67;

/** Tailwind classes for content clearing the fixed primary nav. */
export const PRIMARY_NAV_TOP_CLASS = 'top-[56px] sm:top-[67px]';

/**
 * Mobile bar breakpoint. Matches `@media (max-width: 639px)` in
 * `primary-navigation.css`, where the case selector takes the leftover row.
 */
export const MOBILE_PRIMARY_NAV_MAX_WIDTH_PX = 639;

/** Language and Log Out leave the bar and live in the hamburger at this width. */
export function isMobilePrimaryNav(clientWidth: number | undefined): boolean {
  return clientWidth !== undefined && clientWidth <= MOBILE_PRIMARY_NAV_MAX_WIDTH_PX;
}
